// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".required[data-v-0674372d]{color:var(--error)}[data-v-0674372d] .column-headers{margin-right:75px;margin-bottom:5px}[data-v-0674372d] .box{align-items:normal}[data-v-0674372d] .box .remove{display:flex;flex-direction:column;justify-content:center;align-items:flex-end}[data-v-0674372d] .columns>.col:not(:first-of-type){height:61px}[data-v-0674372d] .columns>.col:first-of-type{min-height:61px}[data-v-0674372d] .columns>.col>*{height:100%}", ""]);
// Exports
module.exports = exports;
